import { ObservableArray, View } from "binder"
import { Tool, ToolManipulationViewModel } from "./toolManipulation-viewModel"
import { ServerSideDataLoader } from "uicomponents";
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";

export class ToolManipulationView extends View<ToolManipulationViewModel> {
    GetViewUniqueId(): string {
        return "V-D36F48DB-4E7C-4C6B-9714-7586629B61FB"
    }
    loadHtml(): string {
        let element = require('./toolManipulation.html').default;
        let style = require('./toolManipulation.less');
        return element;
    }
    constructor() {
        super();
    }

    public set tools(v: ObservableArray<Tool>) { this._tools = v; } public get tools(): ObservableArray<Tool> { return this._tools; } private _tools: ObservableArray<Tool>;
    
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading; } private _isLoading: boolean;
    public set dataLoader(v: ServerSideDataLoader) { this._dataLoader = v; } public get dataLoader(): ServerSideDataLoader { return this._dataLoader; } private _dataLoader: ServerSideDataLoader;
    public set isShowingPopup(v: boolean) { this._isShowingPopup = v; } public get isShowingPopup(): boolean { return this._isShowingPopup; } private _isShowingPopup: boolean;
    public set popup(v: IPopup) { this._popup = v; } public get popup(): IPopup { return this._popup; } private _popup: IPopup;


    createNewTool() {
        this.dataContext.createNewTool();
    }
}
